import React from 'react'
import { Row } from 'react-bootstrap'
import { LoggerProvider } from '../../../../components/Logger/LoggerProvider'
import { InPersonMeetingFileProvider, InPersonMeetingProvider, VolumeProvider } from '../../../in-person-meeting/InPersonMeetingProvider'
import { RecordingView } from '../../../in-person-meeting/views/RecordingView'
import { RoomSession } from '../../../../models/Room'

import classnames from 'classnames'
import { useLoggerConfig } from '../../../in-person-meeting/hooks/useLoggerConfig'
import { NotificationManager } from '../../../in-person-meeting/components/NotificationManager'
import { useNotification } from '../../../in-person-meeting/hooks/useNotification'

interface InPersonMeetingProps {
  accountId: string
  roomSession: RoomSession
}

export const InPersonMeeting: React.FC<InPersonMeetingProps> = ({ accountId, roomSession }) => {
  const { loggerConfig } = useLoggerConfig(accountId, roomSession)
  const { status } = useNotification()

  return (
    <Row className='m-0'>
      <LoggerProvider config={loggerConfig}>
        <InPersonMeetingFileProvider>
          <InPersonMeetingProvider session={roomSession}>
            <VolumeProvider>
              <div
                className={classnames('p-0', 'rounded', {
                  'zocks-bg-color-cyan': status !== 'granted',
                })}
              >
                <div className='p-0 zocks-bg-color-white rounded'>
                  <RecordingView />
                </div>
                {status !== 'not-available' && <NotificationManager />}
              </div>
            </VolumeProvider>
          </InPersonMeetingProvider>
        </InPersonMeetingFileProvider>
      </LoggerProvider>
    </Row>
  )
}
